import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import { StyledInternmentContainer } from "../../../styled/form";

const InternmentContainer = ({ fields, ietModel, representa }) => {
  const evolucionInternacion = representa === "Evolución Internación";
  const disabledFechaProbableDeAlta =
    representa === "Externación" ||
    (evolucionInternacion && ietModel.fechaProbableDeAlta);

  return (
    <StyledInternmentContainer.InternmentContainerWrapper sx={{ mt: 4 }}>
      <FormikDateTimePicker
        name="fechaProbableDeAlta"
        inputVariant="outlined"
        value={ietModel.fechaProbableDeAlta}
        label={`Fecha Probable de Alta ${fields.fechaProbableDeAlta.required ? "*" : ""
          }`}
        disabled={disabledFechaProbableDeAlta}
        sx={StyledInternmentContainer.internmentInput}
        autoComplete="off"
      />
      {evolucionInternacion && (
        <FormikDateTimePicker
          name="fechaProrrogaAlta"
          inputVariant="outlined"
          label={`Fecha Prórroga Alta ${fields.fechaProrrogaAlta.required ? "*" : ""
            }`}
          sx={StyledInternmentContainer.internmentInput}
          autoComplete="off"
        />
      )}
    </StyledInternmentContainer.InternmentContainerWrapper>
  );
};

export default InternmentContainer;
